import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBotInfo } from "../../redux/new-dashboard/dashboardSlice";

function UseFetchDashboardBotPerformance() {
  const {
    main: { userData },
    dashboard: { botInfo, botInfoStatus },
  } = useSelector((state) => state);

  const dispatch = useDispatch();

  useEffect(() => {
    if (
      userData?.email &&
      botInfoStatus !== "loading" &&
      botInfoStatus !== "error" &&
      !Object.keys(botInfo)?.length
    ) {
      dispatch(
        getBotInfo(userData?.["custom:custom_username"], userData?.email),
      );
    }
  }, [botInfo, botInfoStatus, dispatch, userData?.email]);

  return null;
}

export default UseFetchDashboardBotPerformance;
